<div class="video-player {{videoClass}} p-4 max-w-5xl mx-auto">
  <div [id]="resolvedEmbedId" style="width: 100%; position:relative; padding-top: 56.25%;"></div>
</div>
